module.exports = __webpack_public_path__ + "img/doctor.80b5ca75.png";